import { Subscription } from 'rxjs';
import {
  Component,
  Input,
  SimpleChanges,
  Output,
  EventEmitter,
  OnInit,
  ChangeDetectorRef
} from '@angular/core';
import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
} from '@angular/forms';
import {
  AfterContentInit,
  OnChanges,
  OnDestroy,
} from '@angular/core/src/metadata/lifecycle_hooks';
import { Observable } from 'rxjs/Observable';
import { startWith } from 'rxjs/operators/startWith';
import { map } from 'rxjs/operators/map';
import { Ciudad } from '../../../../models/tipo/ciudad.class';
import { RegistroCliente } from '../../../../models/cliente/registro-cliente.class';
import { DireccionCliente } from '../../../../models/cliente/direccion-cliente.class';
import { DireccionProspecto } from '../../../../models/prospecto/direccion-prospecto.class';
import { TipoDireccion } from '../../../../models/tipo/tipo-direccion.class';
import { ConstantesFormularioCliente } from '../constantes-formulario-clientes';
import {
  ParametrizacionVista,
  ValidacionCliente,
} from '../../../../models/cliente/validacion-cliente.class';
import {
  ClienteDireccionService,
  ConsultaEstadoCampoDiferente,
  MensajeInterFormulario,
  ReporteFormDireccion,
} from '../../../../services/cliente-direccion/cliente-direccion.service';
import { RequireMatch } from './requireMatch';
import * as moment from 'moment';

@Component({
  selector: 'app-direccion-cliente',
  templateUrl: './direccion-cliente.component.html',
  styleUrls: ['./direccion-cliente.component.css'],
})

/**
 * TECYMDV-1895 / dacordero@personalsoft.com.co / 2021-07-02 / Obligatoriedad de campos pantalla clientes por producto
 */
export class DireccionClienteComponent
  implements OnInit, OnChanges, AfterContentInit, OnDestroy {
  constantesFormularioCliente: ConstantesFormularioCliente =
    new ConstantesFormularioCliente();

  filteredCiudad: Observable<any[]>;

  // Usado por el detector de cambios de prospecto
  camposDiferentes: string[] = [];

  ejecutarValidador = false;
  ejecutarValidadoresTimer;
  valorCiudad: any;
  flipflop = false;

  @Input()
  parametrizacionVista: ParametrizacionVista;

  formDireccion: FormGroup;
  formularioInicializado = false;
  @Input()
  cliente: RegistroCliente;
  @Input()
  titulo: string;

  // Los nombres de los campos del formulario

  @Input()
  nombreBloque: string;
  @Input()
  nombreControlRadio: string;
  @Input()
  nombreControlDireccion: string;
  @Input()
  nombreControlTelefono: string;
  @Input()
  nombreControlCiudad: string;

  @Input()
  tipoDireccion: String;
  @Input()
  soyProspecto = false;
  @Input()
  direccionDiferencia: any;

  @Input()
  validacionProducto: ValidacionCliente;

  @Input() campoTelefonoLongitud =
    ConstantesFormularioCliente.CAMPO_TELEFONO_LONGITUD;

  /**
   * Los campos acá se muestran en el formulario
   */
  @Input()
  listaCamposVisibles: string[] = [];
  /**
   * Los campos acá incluídos son obligatorios en el formulario
   */
  @Input()
  listaCamposObligatorios: string[] = [];

  @Output()
  direccionInicializada: EventEmitter<string[]> = new EventEmitter();

  subscriptionRevalidarTodosFormularios: Subscription;
  subscriptionLimpiarTodasDirecciones: Subscription;
  subscriptionTraspasoInfoDesdeProspectoACliente: Subscription;
  subscriptionConsultaEstadoCampoDiferente: Subscription;
  subscriptionTraspasarTodosCamposProspecto: Subscription;

  telefono: String = '';
  direccion: String = '';

  @Input()
  infoDireccion: DireccionCliente;

  @Input()
  listCiudades: Ciudad[];

  constructor(
    private cdref: ChangeDetectorRef,
    private formBuilder: FormBuilder,
    private clienteDireccionService: ClienteDireccionService
  ) {
    this.formDireccion = this.formBuilder.group({});
  }

  getCssDiferenciaTipoEnvio(campo: string) {
    return { 'input-diferent-select': this.camposDiferentes.includes(campo) };
  }

  getCssDiferencia(campo: string) {
    return { 'input-diferent-select': this.camposDiferentes.includes(campo) };
  }

  ngAfterContentInit() {
    this.direccionInicializada.emit(['Dirección lista']);
  }

  cargarInformacionDireccion() {
    if (this.infoDireccion) {
      this.telefono = this.infoDireccion.telefono;
      this.direccion = this.infoDireccion.direccion;
    }
  }

  asignarCiudad(idCiudad: String) {
    if (this.listCiudades && this.listCiudades.length >= 1) {
      const ciudad = this.listCiudades.find(function (ciudadItem) {
        return ciudadItem.id && ciudadItem.id === idCiudad;
      });
      if (ciudad) {
        this.valorCiudad = ciudad;
      }
    }
  }

  ngOnChanges(changes: SimpleChanges) {

      this.suscribirObservables();

      if(this.infoDireccion){
        this.asignarCiudad(this.infoDireccion.municipio);
      }

      this.cargarInformacionDireccion();

      setTimeout(() => {
        this.inicioFiltroAutoCompletar();
      }, 1500);


    if (changes.nombreBloque && changes.nombreBloque.currentValue) {
      this.nombreControlRadio =
        this.nombreBloque + ConstantesFormularioCliente.SUFIJO_RADIOCONTROL;
      this.nombreControlDireccion =
        this.nombreBloque + ConstantesFormularioCliente.SUFIJO_DIRECCIONCONTROL;
      this.nombreControlTelefono =
        this.nombreBloque + ConstantesFormularioCliente.SUFIJO_TELEFONOCONTROL;
      this.nombreControlCiudad =
        this.nombreBloque + ConstantesFormularioCliente.SUFIJO_CIUDADCONTROL;

    }


    if (
      changes.validacionProducto &&
      changes.validacionProducto.currentValue &&
      changes.parametrizacionVista
    ) {
      let losCamposOblig = this.parametrizacionVista.camposObligatorios;
      let losCamposVisib = this.parametrizacionVista.camposOpcionales;

      let leTemp = [];
      let losCamposObligTem = [];

      // Limpiar campos obligatorios y visibles
      this.listaCamposVisibles = [];
      this.listaCamposObligatorios = [];

      losCamposOblig.forEach((campoObligatorio) => {
        if (!campoObligatorio.startsWith(ConstantesFormularioCliente.DIRECCIONES_PREFIJO) &&
          !campoObligatorio.startsWith(ConstantesFormularioCliente.DIRECCION_NECESARIA)) {
          losCamposObligTem.push(campoObligatorio);
        }
      });

      losCamposOblig.forEach((unCampo) => {
        if (
          unCampo.startsWith(ConstantesFormularioCliente.DIRECCIONES_PREFIJO) &&
          unCampo.length <
            ConstantesFormularioCliente.DIRECCIONES_PREFIJO.length + 2
        ) {
          const losHijos = [
            unCampo + ConstantesFormularioCliente.SUFIJO_RADIOCONTROL,
            unCampo + ConstantesFormularioCliente.SUFIJO_DIRECCIONCONTROL,
            unCampo + ConstantesFormularioCliente.SUFIJO_TELEFONOCONTROL,
            unCampo + ConstantesFormularioCliente.SUFIJO_CIUDADCONTROL,
          ];

          losHijos.forEach((unHiji) => {
            if (!leTemp.includes(unHiji)) {
              leTemp.push(unHiji);
            }
          });
        }
      });

      leTemp.forEach((unCampoTem) => {
        // concurrencia
        if (!losCamposVisib.includes(unCampoTem)) {
          losCamposVisib.push(unCampoTem);
        }
      });

      losCamposObligTem.forEach((unCamOblig) => {
        if (!this.listaCamposObligatorios.includes(unCamOblig)) {
           this.listaCamposObligatorios.push(unCamOblig);
        }

        if (!this.listaCamposVisibles.includes(unCamOblig)) {
          this.listaCamposVisibles.push(unCamOblig);
        }
      });

      // --

      leTemp = [];

      losCamposVisib.forEach((unCampo) => {
        if (
          unCampo.startsWith(ConstantesFormularioCliente.DIRECCIONES_PREFIJO) &&
          unCampo.length <
            ConstantesFormularioCliente.DIRECCIONES_PREFIJO.length +
              ConstantesFormularioCliente.MAX_SUFIJO_CARACTERES
        ) {
          const losHijos = [
            unCampo + ConstantesFormularioCliente.SUFIJO_RADIOCONTROL,
            unCampo + ConstantesFormularioCliente.SUFIJO_DIRECCIONCONTROL,
            unCampo + ConstantesFormularioCliente.SUFIJO_TELEFONOCONTROL,
            unCampo + ConstantesFormularioCliente.SUFIJO_CIUDADCONTROL,
          ];

          losHijos.forEach((unHiji) => {
            if (!leTemp.includes(unHiji)) {
              leTemp.push(unHiji);
            }
          });
        }
      });

      leTemp.forEach((unCampoTem) => {
        // concurrencia
        if (!losCamposVisib.includes(unCampoTem)) {
          losCamposVisib.push(unCampoTem);
        }
      });

      losCamposVisib = losCamposVisib.filter((unCampo) => {
        return !(
          unCampo.startsWith(ConstantesFormularioCliente.DIRECCIONES_PREFIJO) &&
          unCampo.length <
            ConstantesFormularioCliente.DIRECCIONES_PREFIJO.length +
              ConstantesFormularioCliente.MAX_SUFIJO_CARACTERES
        );
      });

      losCamposVisib.forEach((unCamOpc) => {
        if (!this.listaCamposVisibles.includes(unCamOpc)) {
          this.listaCamposVisibles.push(unCamOpc);
        }
      });

      // Limpiar controles no visibles del formulario (cuando recarga un tipo de documento diferente)
      const losCtls = Object.keys(this.formDireccion.controls);
      if (losCtls.length > 0) {
        losCtls.forEach((element) => {
          if (!this.listaCamposVisibles.includes(element)) {
            this.formDireccion.removeControl(element);
          }
        });
      }

      // -- Agregar los campos de esta dirección al formulario

      this.listaCamposVisibles
        .filter((unCampVis) => unCampVis.startsWith(this.nombreBloque))
        .forEach((unCampDeEstaDireccion) => {
          if (
            !(
              unCampDeEstaDireccion.startsWith(
                ConstantesFormularioCliente.DIRECCIONES_PREFIJO
              ) &&
              unCampDeEstaDireccion.length <
                ConstantesFormularioCliente.DIRECCIONES_PREFIJO.length +
                  ConstantesFormularioCliente.MAX_SUFIJO_CARACTERES
            )
          ) {
            this.agregarReemplazarFormControl(unCampDeEstaDireccion);
          }
        });

      setTimeout(() => {
        this.formularioInicializado = true;
      }, 1000);
    }
  }

  inicioFiltroAutoCompletar(): void {

    this.filteredCiudad = this.formDireccion
      .get(this.nombreControlCiudad)
      .valueChanges.pipe(
        startWith<string | Ciudad>(),
        map((value) => {
          const a = typeof value === 'string';
          return a
            ? value
            : value !== null && value !== undefined
            ? (<Ciudad>value).descripcioncompleta
            : '';
        }),
        map((descripcioncompleta) =>
          descripcioncompleta
            ? this.filterStates(<string>descripcioncompleta)
            : this.listCiudades.slice()
        )
      );
  }

  filterStates(descripcioncompleta: String): Ciudad[] {
    descripcioncompleta.toLocaleLowerCase();
    return this.listCiudades.filter(
      (ciudad) =>
        ciudad.descripcioncompleta
          .toLowerCase()
          .indexOf(descripcioncompleta.toLowerCase()) === 0
    );
  }

  displayFn(ciudad?: Ciudad): String | undefined {
    return ciudad ? ciudad.descripcioncompleta : undefined;
  }

  esObligatorioDireccion(): boolean {
    if (
      this.elementosNovacios()
    ) {
      return true;
    }

    return false;
  }

  cambioCorrespondencia(event: any) {
    this.cliente.correspondenciaSeleccionada = event.value;
    let losCamposOblig = this.parametrizacionVista.camposObligatorios;
    losCamposOblig.forEach(element => {
      if(!this.listaCamposObligatorios.includes(element) && element.startsWith(this.nombreBloque)){
          this.listaCamposObligatorios.push(element);
      };
    });
  }

  traspasarInfoDireccion() {
    const listControls = [
      this.nombreControlDireccion,
      this.nombreControlTelefono,
      this.nombreControlCiudad,
      this.titulo.concat(ConstantesFormularioCliente.TITULO_CIUDAD),
    ];
    if (this.cliente.correspondenciaSeleccionada === this.tipoDireccion) {
      listControls.push(this.nombreControlRadio);
    }

    listControls.forEach((unNombreCtl) => this.traspasoProspecto(unNombreCtl));
  }

  traspasoProspecto(formControl: string) {
    const control = this.formDireccion.get(formControl);

    if (control) {
      const val = control.value;

      if (val) {
        this.clienteDireccionService.setTraspasoInfoDesdeProspectoACliente(
          new MensajeInterFormulario(formControl, val)
        );
      }
    }
  }

  elementosNovacios(): boolean {
    let noVacios = false;
    if (
      (this.telefono && this.telefono !== '') ||
      (this.direccion && this.direccion !== '') ||
      (this.infoDireccion &&
        this.infoDireccion.municipio !== '' &&
        this.infoDireccion.municipio !== undefined &&
        this.infoDireccion.municipio !== null &&
        this.infoDireccion.municipio !== null) ||
      this.cliente.correspondenciaSeleccionada === this.tipoDireccion
    ) {
      noVacios = true;
    }
    return noVacios;
  }

  getDireccionCliente(
    correoElectronico: String,
    tipoCorreoElectornico: String
  ): DireccionCliente {
    if(this.direccion || this.telefono || this.valorCiudad){
    const direccion: DireccionCliente = new DireccionCliente();
    direccion.tipoDireccion = this.tipoDireccion;

    this.setCorreoElectronicoDireccion(
      correoElectronico,
      tipoCorreoElectornico,
      direccion
    );
    this.setCorrespondenciaFisica(direccion);
    direccion.direccion = this.direccion;
    direccion.telefono = (this.telefono) ? `${this.telefono}`: null;

    direccion.municipio = this.valorCiudad.id;
    direccion.departamento = this.valorCiudad.cddpto;

    return direccion;
  }
  return null;
  }

  getDireccionProspecto(
    correoElectronico: String,
    tipoCorreoElectornico: String
  ): DireccionProspecto {
    const munic =
      this.valorCiudad && this.valorCiudad.id ? this.valorCiudad.id : null;

    const ret = new DireccionProspecto(
      this.cargarTipoDireccion(this.tipoDireccion),
      this.direccion,

      munic,

      (this.telefono) ? `${this.telefono}`: null,
      this.getCorrespondenciaFisicaProspecto(),
      this.getCorreoElectronico(correoElectronico, tipoCorreoElectornico),
      this.getesEmailCorrespondencia(correoElectronico, tipoCorreoElectornico)
    );

    return ret;
  }

  cargarTipoDireccion(tipoDireccion: String): TipoDireccion {
    return TipoDireccion.getLista().find(
      (unTipo) => unTipo.id === tipoDireccion
    );
  }

  crearTipoDireccion(id: String, descripcion: String) {
    return new TipoDireccion(id, descripcion);
  }

  setCorrespondenciaFisica(direccion: DireccionCliente) {
    if (this.cliente.correspondenciaSeleccionada === this.tipoDireccion) {
      direccion.correspondenciaFisica = true;
    } else {
      direccion.correspondenciaFisica = false;
    }
  }

  getCorrespondenciaFisicaProspecto(): String {
    let esvalida: String = ConstantesFormularioCliente.LITERAL_NO;
    if (this.cliente.correspondenciaSeleccionada === this.tipoDireccion) {
      esvalida = ConstantesFormularioCliente.LITERAL_SI;
    }
    return esvalida;
  }

  setCorreoElectronicoDireccion(
    correoElectronico: String,
    tipoCorreoElectornico: String,
    direccion: DireccionCliente
  ) {
    if (
      correoElectronico !== null &&
      tipoCorreoElectornico !== null &&
      tipoCorreoElectornico === this.tipoDireccion
    ) {
      direccion.correoElectronico = correoElectronico;
      direccion.correspondenciaElectronica = true;
    } else {
      direccion.correspondenciaElectronica = false;
    }
  }

  getCorreoElectronico(
    correoElectronico: String,
    tipoCorreoElectornico: String
  ): String {
    let email: String = '';

    if (
      this.validarContieneCorreoElectronico(
        correoElectronico,
        tipoCorreoElectornico
      )
    ) {
      email = correoElectronico;
    }
    return email;
  }

  getesEmailCorrespondencia(
    correoElectronico: String,
    tipoCorreoElectornico: String
  ): String {
    let esEmailCorrespondencia = ConstantesFormularioCliente.LITERAL_NO;
    if (
      this.validarContieneCorreoElectronico(
        correoElectronico,
        tipoCorreoElectornico
      )
    ) {
      esEmailCorrespondencia = ConstantesFormularioCliente.LITERAL_SI;
    }
    return esEmailCorrespondencia;
  }

  cicloValidacion() {
    this.ejecutarValidadoresTimer = setInterval(() => {
      // Detección de diferencias
      if (this.soyProspecto) {
        const losControles: string[] = Object.keys(this.formDireccion.controls);

        losControles.forEach((unCtl) => {
          this.clienteDireccionService.setConsultaEstadoCampoDiferente(
            new ConsultaEstadoCampoDiferente(
              unCtl,
              this.formDireccion.get(unCtl).value,
              () => {
                if (this.camposDiferentes.includes(unCtl)) {
                  this.camposDiferentes = this.camposDiferentes.filter(
                    (unCamp) => unCamp !== unCtl
                  );
                }
              },
              () => {
                if (!this.camposDiferentes.includes(unCtl)) {
                  this.camposDiferentes.push(unCtl);
                }
              }
            )
          );
        });
      }

      if (!this.ejecutarValidador) {
        clearInterval(this.ejecutarValidadoresTimer);
      }
    }, 2000);
  }

  ngOnInit(): void {
    this.ejecutarValidador = true;
    this.cicloValidacion();
  }

  esCiudadDisabled(): boolean {
    if (!this.soyProspecto) {
      return false;
    }
    return true;
  }

  validarContieneCorreoElectronico(
    correoElectronico: String,
    tipoCorreoElectronico: String
  ): boolean {
    let contiene = false;
    if (
      correoElectronico &&
      tipoCorreoElectronico &&
      tipoCorreoElectronico === this.tipoDireccion
    ) {
      contiene = true;
    }
    return contiene;
  }

  esCampoRequerido(nomControl: string): boolean {
    let losCamposOblig = this.parametrizacionVista.camposObligatorios;
    if (losCamposOblig.includes(nomControl) && (this.cliente.correspondenciaSeleccionada===this.tipoDireccion)) {
      return true;
    }

    if(losCamposOblig.includes(nomControl) && (!(this.telefono) && !(this.direccion) && !(this.valorCiudad && this.valorCiudad.id) )){

      return false;
    }

    if(losCamposOblig.includes(nomControl) && ((this.telefono !== '') || (this.direccion !== '') || (this.valorCiudad && this.valorCiudad.id))){

      return true;
    }

    return false;
  }

  esCampoVisible(nomControl: string): boolean {
    if (this.listaCamposVisibles.includes(nomControl)) {
      return true;
    }

    if (
      !this.listaCamposVisibles.includes(nomControl) &&
      this.listaCamposVisibles.includes(this.nombreBloque)
      || this.esObligatorioDireccion()
    ) {
      return true;
    }

    return false;
  }

  getErrors(errObj: any): string {
    const ret = [];

    if (errObj.required) {
      ret.push('required: ' + errObj.required);
    }

    return ret.join(' | ');
  }

  agregarReemplazarFormControl(nombreUnCampo: string) {
    const esObligatorio = this.listaCamposObligatorios.includes(nombreUnCampo);

    const valorInicial = {
      disabled: this.soyProspecto,
    };

    const validaciones = nombreUnCampo.includes(ConstantesFormularioCliente.SUFIJO_CIUDADCONTROL)
      ? [Validators.required, RequireMatch]
      : [Validators.required];
      const validacionesTel = (esObligatorio) ? [Validators.required, this.customValidator] : [this.customValidator];

    if (this.formDireccion.contains(nombreUnCampo)) {
      valorInicial['value'] = this.formDireccion.get(nombreUnCampo).value;

      this.formDireccion.setControl(
        nombreUnCampo,
        new FormControl(valorInicial, esObligatorio ? validaciones : null)
      );
    } else {
      valorInicial['value'] = '';
      this.formDireccion.addControl(
        nombreUnCampo,
        new FormControl(valorInicial, (nombreUnCampo.includes(ConstantesFormularioCliente.SUFIJO_TELEFONOCONTROL)) ? validacionesTel : esObligatorio ? validaciones : null)
      );
    }
  }

  customValidator(control) {
    const value: string = control.value.toString();
    if (value && value.length !== 7 && value.length !== 10) {
      return { invalidLength: true };
    }else if (value && value.length === 10 && !/^(601|602|604|605|606|607|608)/.test(value)) {
      return { invalidIndicative: true };
    }
    return null;
  }

  cambioFormDireccion($event: any) {
        let losCamposOblig = this.parametrizacionVista.camposObligatorios;
        losCamposOblig.forEach(element => {
          if(!this.listaCamposObligatorios.includes(element) && element.startsWith(this.nombreBloque)){
            this.listaCamposObligatorios.push(element);
          };
        });
    this.reportarErrorDeFormulario();
  }

  camposVisiblesHayAlgo() {
    return this.listaCamposVisibles.filter((unCamp) => {
      return (
        unCamp !== this.nombreBloque && unCamp.startsWith(this.nombreBloque)
      );
    });
  }

  suscribirObservables() {
    if (!this.soyProspecto) {
      // Cliente

      if (
        !this.subscriptionLimpiarTodasDirecciones ||
        this.subscriptionLimpiarTodasDirecciones.closed
      ) {
        this.subscriptionLimpiarTodasDirecciones = this.clienteDireccionService
          .getLimpiarTodasDirecciones()
          .subscribe(() => {
            this.infoDireccion = null;
            this.direccion = null;
            this.telefono = null;
            this.valorCiudad = null;
            this.cliente.correspondenciaSeleccionada = null;
          });
      }

      // ---

      if (
        !this.subscriptionRevalidarTodosFormularios ||
        this.subscriptionRevalidarTodosFormularios.closed
      ) {
        this.subscriptionRevalidarTodosFormularios =
          this.clienteDireccionService
            .getRevalidarTodosFormularios()
            .subscribe((revalidarForms) => {
              setTimeout(() => {
                this.reportarErrorDeFormulario();
              }, 500 * Math.random());
            });
      }

      // ---

      if (
        !this.subscriptionTraspasoInfoDesdeProspectoACliente ||
        this.subscriptionTraspasoInfoDesdeProspectoACliente.closed
      ) {
        this.subscriptionTraspasoInfoDesdeProspectoACliente =
          this.clienteDireccionService
            .getTraspasoInfoDesdeProspectoACliente()
            .subscribe((mensajeInterForm) => {
              const campo = this.formDireccion.get(
                mensajeInterForm.nombreCampo
              );

              if (campo) {
                campo.setValue(mensajeInterForm.valor);
              }

            });
      }

      // ---

      if (
        !this.subscriptionConsultaEstadoCampoDiferente ||
        this.subscriptionConsultaEstadoCampoDiferente.closed
      ) {
        this.subscriptionConsultaEstadoCampoDiferente =
          this.clienteDireccionService
            .getConsultaEstadoCampoDiferente()
            .subscribe((mensajeComprobacion) => {
              const campoCliente = this.formDireccion.get(
                mensajeComprobacion.nombreCampo
              );

              if (campoCliente) {
                let iguales = false;

                // Comparar ciudad
                if (
                  mensajeComprobacion.nombreCampo.endsWith(
                    ConstantesFormularioCliente.SUFIJO_CIUDADCONTROL
                  )
                ) {

                  iguales =
                    mensajeComprobacion.valorActual.id ===
                    campoCliente.value.id;
                } else {

                  iguales =
                    mensajeComprobacion.valorActual === campoCliente.value;
                }

                if (iguales) {
                  if (mensajeComprobacion.accionSiIgual) {
                    mensajeComprobacion.accionSiIgual();
                  }
                } else {
                  if (mensajeComprobacion.accionSiDiferente) {
                    mensajeComprobacion.accionSiDiferente();
                  }
                }
              }

            });
      }
    } else {
      // Prospecto

      if (
        !this.subscriptionTraspasarTodosCamposProspecto ||
        this.subscriptionTraspasarTodosCamposProspecto.closed
      ) {
        this.subscriptionTraspasarTodosCamposProspecto =
          this.clienteDireccionService
            .getTraspasarTodosCamposProspecto()
            .subscribe((deboTraspasar) => {
              Object.keys(this.formDireccion.controls).forEach(
                (unNombreCampo) => {
                  setTimeout(() => {
                    this.traspasoProspecto(unNombreCampo);
                  }, 200 * Math.random() + 50);
                }
              );
            });
      }
    }
  }

  reportarErrorDeFormulario() {
    this.formDireccion.updateValueAndValidity();

    let err = false;
    const controlLength =
      ConstantesFormularioCliente.DIRECCIONES_PREFIJO.length +
      ConstantesFormularioCliente.MAX_SUFIJO_CARACTERES;

    const controlConError: any = this.formDireccion.controls;
    const busqueda = Object.keys(controlConError)
      .filter((unCamp) => unCamp.length > controlLength)
      .find((unControl) => {
        const ctl = controlConError[unControl];

        return ctl.valid === false;
      });

    err = busqueda ? true : false;

    this.clienteDireccionService.setReporteFormDireccion(
      new ReporteFormDireccion(this.nombreBloque, err, busqueda)
    );

    if (!this.flipflop) {
      setTimeout(() => {
        this.flipflop = true;
        this.reportarErrorDeFormulario();
      }, 500);
    } else {
      this.flipflop = false;
    }
  }
  ngOnDestroy(): void {
    if (!this.soyProspecto) {
      if (
        this.subscriptionLimpiarTodasDirecciones &&
        !this.subscriptionLimpiarTodasDirecciones.closed
      ) {
        this.subscriptionLimpiarTodasDirecciones.unsubscribe();
      }
      if (
        this.subscriptionRevalidarTodosFormularios &&
        !this.subscriptionRevalidarTodosFormularios.closed
      ) {
        this.subscriptionRevalidarTodosFormularios.unsubscribe();
      }

      if (
        this.subscriptionTraspasoInfoDesdeProspectoACliente &&
        !this.subscriptionTraspasoInfoDesdeProspectoACliente.closed
      ) {
        this.subscriptionTraspasoInfoDesdeProspectoACliente.unsubscribe();
      }
    }

    this.ejecutarValidador = false;
  }

  /**
   * Si el valor es vacío entonces cuando elimina la ciudad se limpia la propiedad
   * this.infoDireccion.municipio. De lo contrario no hace nada
   */
  modificacionCiudad($event) {
    setTimeout(() => {
      if (this.valorCiudad && this.valorCiudad.id) {
        console.log('modificacionCiudad | Dirección: ', this.valorCiudad);
      } else {
        console.error(
          'modificacionCiudad | Selección sucia: ',
          this.valorCiudad
        );
        this.infoDireccion.municipio = null;
        this.valorCiudad = null;
      }
    }, 500);
  }

  validarCiudad() {
    return (this.valorCiudad !== undefined && this.valorCiudad !== null && this.valorCiudad.id !== null);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/cliente/registro-cliente/direccion-cliente/direccion-cliente.component.ts